/**
 * Venue gallery carousel
 * Scopes each .venue-gallery independently so multiple carousels
 * on the Class Venues page work without interfering.
 */
export default function setupVenueCarousel() {
  document.querySelectorAll('.venue-gallery').forEach(wrapper => {
    const track = wrapper.querySelector('.venue-carousel')
    if (!track) return

    const slides = track.querySelectorAll('.venue-carousel__slide')
    if (slides.length <= 1) return

    const dots = wrapper.querySelectorAll('.venue-carousel__dot')
    const prev = wrapper.querySelector('.venue-carousel__btn--prev')
    const next = wrapper.querySelector('.venue-carousel__btn--next')
    let current = 0

    function goTo(i) {
      current = (i + slides.length) % slides.length
      track.style.transform = `translateX(-${current * 100}%)`
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current))
    }

    if (prev) prev.addEventListener('click', () => goTo(current - 1))
    if (next) next.addEventListener('click', () => goTo(current + 1))
    dots.forEach((dot, idx) => dot.addEventListener('click', () => goTo(idx)))
  })
}
